import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackClick } from '../utils/analytics';
import {
  MinimalGlobalStyle,
  Container,
  Inner,
  BackButton,
  Header,
  HeroRow,
  Avatar,
  HeroText,
  PageTitle,
  Bio,
  HeaderLinks,
  HeaderLink,
  Section,
  SectionTitle,
  Card,
  CardTop,
  CardTitle,
  CardDescription,
  CardLinks,
  InternalLink,
  ProjectCard,
  StatsGrid,
  StatCell,
  StatValue,
  StatLabel,
} from '../components/minimal';
import {
  securityResearch,
  openSource,
  apps,
  research,
  leadership,
  musicStats,
} from '../data/portfolio';

const PortfolioPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLinkClick = (project: string, label: string) => {
    trackClick('portfolio_link', { project, link_type: label });
  };

  return (
    <>
      <MinimalGlobalStyle />
      <Container>
        <BackButton />
        <Inner>
          <Header>
            <HeroRow>
              <Avatar>
                <img src="/profile.jpg" alt="Thomas Ryan" />
              </Avatar>
              <HeroText>
                <PageTitle>Thomas Ryan</PageTitle>
                <Bio>
                  Software engineer and engineering leader. I ship products, build teams,
                  find bugs in kernels and browsers, and create developer tools.
                </Bio>
              </HeroText>
            </HeroRow>
            <HeaderLinks>
              <HeaderLink as="button" onClick={() => { trackClick('portfolio_to_build'); navigate('/build'); }}>
                &rarr; Build
              </HeaderLink>
              <HeaderLink href="https://github.com/Atomics-hub" target="_blank" rel="noopener noreferrer">GitHub</HeaderLink>
              <HeaderLink href="https://x.com/A5omic" target="_blank" rel="noopener noreferrer">X</HeaderLink>
              <HeaderLink href="https://open.spotify.com/artist/7L3rQbwQVEGa71Ign85jyd" target="_blank" rel="noopener noreferrer">Spotify</HeaderLink>
              <HeaderLink href="https://youtube.com/@A5omic" target="_blank" rel="noopener noreferrer">YouTube</HeaderLink>
            </HeaderLinks>
          </Header>

          <Section>
            <SectionTitle>Leadership &amp; Experience</SectionTitle>
            {leadership.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Security Research</SectionTitle>
            {securityResearch.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Open Source</SectionTitle>
            {openSource.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Apps &amp; Products</SectionTitle>
            {apps.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
            <Card>
              <CardTop>
                <CardTitle>23+ Web Applications</CardTitle>
              </CardTop>
              <CardDescription>
                Shipped web apps spanning AI tools, real-time data visualization, games, and developer utilities. All deployed on Firebase.
              </CardDescription>
              <CardLinks>
                <InternalLink onClick={() => { trackClick('portfolio_web_apps'); navigate('/web-apps'); }}>
                  View all &rarr;
                </InternalLink>
              </CardLinks>
            </Card>
          </Section>

          <Section>
            <SectionTitle>Research</SectionTitle>
            {research.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Music</SectionTitle>
            <StatsGrid>
              <StatCell>
                <StatValue>{musicStats.monthlyListeners}</StatValue>
                <StatLabel>Monthly Spotify listeners</StatLabel>
              </StatCell>
              <StatCell>
                <StatValue>{musicStats.tracks}</StatValue>
                <StatLabel>Published tracks</StatLabel>
              </StatCell>
              <StatCell>
                <StatValue>{musicStats.monthlyViews}</StatValue>
                <StatLabel>Monthly YouTube views</StatLabel>
              </StatCell>
            </StatsGrid>
          </Section>
        </Inner>
      </Container>
    </>
  );
};

export default PortfolioPage;
